module.exports = __webpack_public_path__ + "img/cartel.2b3de08c.png";